import { useNavigate } from "react-router-dom";
import { HandleSSOCallback } from "@clerk/react";
import { AuthLoading, AuthShell } from "@/components/auth/AuthLayout";
import { navigateToApp } from "@/components/auth/auth-utils";

/**
 * Google / Microsoft land here (redirectCallbackUrl). Clerk finishes the
 * sign-in or sign-up — rendering its captcha if one is needed — then hands
 * back to the app, to sign-in for an extra factor, or to sign-up when the
 * new account still needs something (production's legal consent).
 */
export default function SSOCallback() {
  const navigate = useNavigate();
  return (
    <AuthShell headline="Amy kept your creator conversations moving while you were away.">
      <AuthLoading title="Signing you in" description="Just a moment…" />
      <HandleSSOCallback
        navigateToApp={navigateToApp(navigate)}
        navigateToSignIn={() => navigate("/login", { replace: true })}
        navigateToSignUp={() => navigate("/signup?continue", { replace: true })}
      />
    </AuthShell>
  );
}
